/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/info': {
    width: 17,
    height: 16,
    viewBox: '0 0 17 16',
    data: '<path pid="0" _fill="#00778F" fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zM9 3v2H7V3h2zm0 10V7H7v6h2z" clip-rule="evenodd"/>'
  }
})
